import React, { useEffect } from "react";
import { LuPlus } from "react-icons/lu";
import { useLazyGetprescriptionpatienthistoryQuery } from "../../State/Api/AddPrescriptionApiSlice";

const PatientPrescription = ({ patientUserUniqueID }) => {
  const [
    fetchpatientPrescription,
    { data: patientprescriptionData = [], isFetching },
  ] = useLazyGetprescriptionpatienthistoryQuery();

  useEffect(() => {
    if (patientUserUniqueID) {
      fetchpatientPrescription(patientUserUniqueID);
    }
  }, [patientUserUniqueID, fetchpatientPrescription]);

  const completedPrescriptions = Array.isArray(patientprescriptionData)
    ? patientprescriptionData : [];

  return (
    <div className="mt-2 space-y-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
      <div className="rounded-lg border bg-white text-gray-800 shadow-sm">
        <div className="space-y-1.5 p-4 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div>
            <h2 className="text-xl xl:text-2xl font-semibold leading-tight mb-2 tracking-tight">
              Prescriptions
            </h2>
            <div className="text-sm text-muted-foreground">
              View all medications and prescriptions.
            </div>
          </div>
          {/* <button className="inline-flex items-center gap-2 rounded-md text-sm font-medium bg-[#171717] text-white hover:bg-[#2e2e2e] h-10 px-4 py-2 gradient-button">
            <LuPlus className="h-4 w-4" /> Add Prescription
          </button> */}
        </div>

        {/* Prescription Table */}
        <div className="p-4">
          <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <table className="w-full text-sm text-left text-gray-500">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                <tr>
                  <th scope="col" className="px-6 py-3">
                    Diagnosis
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Prescription Type
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Date Range
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Doctor
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Status
                  </th>
                  {/* <th scope="col" className="px-6 py-3">Action</th> */}
                </tr>
              </thead>
              <tbody>
                {completedPrescriptions.length > 0 ? (
                  completedPrescriptions.map((prescription, index) => (
                    <tr
                      key={index}
                      className="odd:bg-white even:bg-gray-50 border-b border-gray-200"
                    >
                      <th
                        scope="row"
                        className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap"
                      >
                        {prescription?.diagnosis}
                      </th>
                      <td className="px-6 py-4">
                        {prescription?.prescriptionType}
                      </td>
                      <td className="px-6 py-4">
                        {prescription?.prescriptionDate
                          ? new Date(prescription.prescriptionDate)
                              .toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })
                              .replace(/ /g, "-")
                          : "N/A"}
                      </td>
                      <td className="px-6 py-4">{prescription?.doctor}</td>
                      <td className="px-6 py-4">
                        <span
                          className={`inline-flex items-center rounded-full text-white px-2.5 py-0.5 text-xs font-semibold
                            ${
                              prescription?.status === "In Progress"
                                ? "bg-yellow-500"
                                : prescription?.status === "Today"
                                ? "bg-red-500"
                                : prescription?.status === "Completed"
                                ? "bg-green-500"
                                : "bg-gray-400"
                            }
                          `}
                        >
                          {prescription?.status}
                        </span>
                      </td>
                      {/* <td className="px-6 py-4">
                        <a
                          href="#"
                          className="font-medium text-blue-600 hover:underline"
                        >
                          Edit
                        </a>
                      </td> */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="6"
                      className="px-6 py-4 text-center text-gray-500"
                    >
                      No prescriptions available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientPrescription;
